(function () {
  'use strict';

  const modal = document.getElementById('OcCotizador');
  if (!modal) return;

  const form = document.getElementById('OcCotizadorForm');
  const whatsappNumber = modal.dataset.whatsapp;
  const brand = modal.dataset.brand || 'Dayrosse';

  const steps = modal.querySelectorAll('[data-cotizador-step]');
  const stepLabels = modal.querySelectorAll('[data-step-label]');
  const progressBar = modal.querySelector('[data-cotizador-progress]');
  const nextButtons = modal.querySelectorAll('[data-cotizador-next]');
  const backButtons = modal.querySelectorAll('[data-cotizador-back]');
  const closeButtons = document.querySelectorAll('[data-cotizador-close]');
  const openButtons = document.querySelectorAll('[data-cotizador-open]');

  const state = {
    currentStep: 1,
    totalSteps: 3,
    data: {},
  };

  // =========================
  // OPEN / CLOSE
  // =========================
  function open(preselectedType) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('oc-cotizador-open');
    goToStep(1);

    if (preselectedType) {
      const radio = form.querySelector(`input[name="event_type_radio"][value="${preselectedType}"]`);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('oc-cotizador-open');
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const preselected = btn.dataset.cotizadorOpen;
      open(preselected || null);
    });
  });

  // Catch clicks on any link with #cotizador or #cotizador-{type} hash
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="#cotizador"]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const match = href.match(/#cotizador(?:-([a-z-]+))?/i);
    if (!match) return;
    e.preventDefault();
    open(match[1] || null);
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      close();
    }
  });

  // Expose global helper for buttons added later
  window.openCotizador = open;

  // =========================
  // STEP NAVIGATION
  // =========================
  function goToStep(stepNumber) {
    state.currentStep = stepNumber;

    steps.forEach(function (step) {
      const stepId = step.dataset.cotizadorStep;
      step.classList.toggle('is-active', stepId == stepNumber || (stepNumber === 'success' && stepId === 'success'));
    });

    stepLabels.forEach(function (label) {
      const num = parseInt(label.dataset.stepLabel, 10);
      label.classList.toggle('is-active', num <= (typeof stepNumber === 'number' ? stepNumber : 3));
    });

    if (typeof stepNumber === 'number') {
      const percent = ((stepNumber - 1) / (state.totalSteps - 1)) * 100;
      progressBar.style.width = percent + '%';
    } else if (stepNumber === 'success') {
      progressBar.style.width = '100%';
    }

    // Scroll modal to top
    const dialog = modal.querySelector('.oc-cotizador__dialog');
    if (dialog) dialog.scrollTop = 0;
  }

  nextButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (validateStep(state.currentStep)) {
        if (state.currentStep < state.totalSteps) {
          goToStep(state.currentStep + 1);
        }
      }
    });
  });

  backButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (state.currentStep > 1) {
        goToStep(state.currentStep - 1);
      }
    });
  });

  // =========================
  // STEP 1: Event type
  // =========================
  const eventRadios = form.querySelectorAll('input[name="event_type_radio"]');
  const step1NextBtn = form.querySelector('[data-cotizador-step="1"] [data-cotizador-next]');
  const eventTypeHidden = form.querySelector('[data-field="event_type"]');

  eventRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      const label = radio.dataset.eventLabel;
      state.data.event_type = label;
      state.data.event_value = radio.value;
      eventTypeHidden.value = label;
      step1NextBtn.disabled = false;
      updateConditionalFields(radio.value);
    });
  });

  function updateConditionalFields(value) {
    const conditionalFields = form.querySelectorAll('[data-show-for]');
    conditionalFields.forEach(function (field) {
      const showFor = field.dataset.showFor.split(',');
      if (showFor.includes(value)) {
        field.removeAttribute('hidden');
      } else {
        field.setAttribute('hidden', '');
        // Clear value when hidden
        const input = field.querySelector('input, select, textarea');
        if (input) input.value = '';
      }
    });
  }

  // =========================
  // VALIDATION
  // =========================
  function validateStep(stepNumber) {
    if (stepNumber === 1) {
      const checked = form.querySelector('input[name="event_type_radio"]:checked');
      return !!checked;
    }

    if (stepNumber === 2) {
      return true; // All step 2 fields are optional
    }

    if (stepNumber === 3) {
      const nombre = form.querySelector('[data-field="nombre"]');
      const telefono = form.querySelector('[data-field="telefono"]');
      const email = form.querySelector('[data-field="email"]');

      let valid = true;
      [nombre, telefono, email].forEach(function (input) {
        if (!input.value.trim()) {
          input.style.borderColor = '#d44';
          valid = false;
        } else {
          input.style.borderColor = '';
        }
      });
      return valid;
    }

    return true;
  }

  // =========================
  // BUILD SUMMARY & SUBMIT
  // =========================
  function collectFormData() {
    const data = {};
    form.querySelectorAll('[data-field]').forEach(function (el) {
      if (el.type === 'hidden') return;
      const key = el.dataset.field;
      data[key] = el.value.trim();
    });
    data.event_type = state.data.event_type;
    return data;
  }

  function buildDetailsSummary(data) {
    const lines = [];
    if (data.fecha) lines.push('Fecha: ' + data.fecha);
    if (data.invitados) lines.push('Invitados: ' + data.invitados);
    if (data.personas) lines.push('Personas: ' + data.personas);
    if (data.lugar) lines.push('Lugar: ' + data.lugar);
    if (data.presupuesto) lines.push('Presupuesto: ' + data.presupuesto);
    if (data.notas) lines.push('Notas: ' + data.notas);
    return lines.join(' · ');
  }

  function buildWhatsAppMessage(data) {
    const lines = [];
    lines.push('Hola ' + brand + ',');
    lines.push('');
    lines.push('Me gustaría cotizar el siguiente evento: *' + (data.event_type || 'Ocasión especial') + '*.');
    lines.push('');
    lines.push('*Detalles:*');

    if (data.fecha) lines.push('- Fecha: ' + data.fecha);
    if (data.invitados) lines.push('- Invitados: ' + data.invitados);
    if (data.personas) lines.push('- Personas: ' + data.personas);
    if (data.lugar) lines.push('- Lugar: ' + data.lugar);
    if (data.presupuesto) lines.push('- Presupuesto: ' + data.presupuesto);
    if (data.notas) {
      lines.push('');
      lines.push('*Notas:*');
      lines.push(data.notas);
    }
    lines.push('');
    lines.push('*Mis datos:*');
    lines.push('- Nombre: ' + data.nombre);
    lines.push('- Email: ' + data.email);
    lines.push('- WhatsApp: ' + data.telefono);
    lines.push('');
    lines.push('¡Gracias!');

    return lines.join('\n');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!validateStep(3)) return;

    const data = collectFormData();
    const summary = buildDetailsSummary(data);
    form.querySelector('[data-field="details_summary"]').value = summary;

    const message = buildWhatsAppMessage(data);
    const waUrl = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(message);

    // Submit the Shopify contact form via fetch (record in Shopify admin notifications)
    const formData = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
    }).catch(function () {
      // Silent fail — WhatsApp is the primary channel
    });

    // Open WhatsApp with pre-filled message
    window.open(waUrl, '_blank');

    // Show success state
    goToStep('success');

    // Reset after a delay
    setTimeout(function () {
      form.reset();
      step1NextBtn.disabled = true;
      const conditionalFields = form.querySelectorAll('[data-show-for]');
      conditionalFields.forEach(function (f) { f.setAttribute('hidden', ''); });
    }, 1000);
  });

  // Initial state
  updateConditionalFields('');
})();
